// import { Component, OnInit, OnDestroy, HostListener, inject } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Firestore, collection, doc, setDoc, serverTimestamp, Timestamp, getDoc } from '@angular/fire/firestore';
// import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// import { HttpClient } from '@angular/common/http';
// import { environment } from '../../environments/environment';


// interface Service {
//   id: number;
//   name: string;
//   description: string;
//   icon: {
//     key: string;
//     svg: string;
//   };
//   featured: boolean;
// }


// interface Doctor {
//   id: number;
//   doctorname: string;
//   qualification: string;
//   specialization: string;
//   experience: string;
//   imageurl: string;
// }

// interface Testimonial {
//   id: number;
//   testimonial: string;
//   patientName: string;
//   rating: number;
// }

// interface ClinicSettings {
//   phone_numbers: string[];
//   email: string;
//   working_hours: string;
// }

// interface FAQItem {
//   id: string;
//   question: string;
//   answer: string;
//   isOpen: boolean;
// }

// @Component({
//   selector: 'app-mainwebpage',
//   standalone: true,
//   imports: [CommonModule, FormsModule, ReactiveFormsModule],
//   templateUrl: './mainwebpage.component.html',
//   styleUrl: './mainwebpage.component.css'
// })
// export class MainWebpageComponent implements OnInit, OnDestroy {
//   private sanitizer = inject(DomSanitizer);

//   services: Service[] = [];
//   testimonials: Testimonial[] = [];
//   doctors: Doctor[] = []
//   clinicSettings: ClinicSettings = {
//     phone_numbers: ['+91 98765 43210', '+91 98765 43211'],
//     email: 'info@enlightenphysio.com',
//     working_hours: 'Mon-Sat: 8AM - 9PM | Sun: 9AM - 6PM'
//   };
//   faqItems: FAQItem[] = []
//   serviceTypes: string[] = [];

//   isScrolled = false;
//   mobileMenuOpen = false;
//   isSubmitting = false;
//   appointmentForm!: FormGroup;
//   toastMessage = '';
//   toastType: 'success' | 'error' = 'success';
//   showToast = false;
//   currentYear = new Date().getFullYear();
//   serviceDropdownOpen = false;

//   constructor(private fb: FormBuilder,private firestore: Firestore,private http:HttpClient) {}

//   ngOnInit(): void {
//     this.appointmentForm = this.fb.group({
//       patient_name: ['', Validators.required],
//       phone: ['', Validators.required],
//       email: ['', Validators.email],
//       preferred_date: ['', Validators.required],
//       preferred_time: [''],
//       service_type: ['', Validators.required],
//       message: ['']
//     });
//     this.loadServices();
//     this.loadtestimonials();
//     this.loaddoctors();
//     this.loadServiceTypes();
//     this.loadFaq();
//   }

//   ngOnDestroy(): void {}
//   async loadServices(): Promise<void> {
//     const snap = await getDoc(doc(this.firestore, 'webdata', 'services'));

//     if (snap.exists()) {
//       this.services = snap.data()['services'] || [];
//     } else {
//       this.services = [];
//     }
//   }
//   async loadFaq(): Promise<void> {
//     const snap = await getDoc(doc(this.firestore, 'webdata', 'faq'));

//     if (snap.exists()) {
//       this.faqItems = snap.data()['faq'] || [];
//     } else {
//       this.faqItems = [];
//     }
//   }
  
//   async loaddoctors(): Promise<void> {
//     const snap = await getDoc(doc(this.firestore, 'webdata', 'doctors'));

//     if (snap.exists()) {
//       this.doctors = snap.data()['doctors'] || [];
//     } else {
//       this.doctors = [];
//     }
//   }
//   async loadtestimonials(): Promise<void> {
//     const snap = await getDoc(doc(this.firestore, 'webdata', 'testimonials'));

//     if (snap.exists()) {
//       this.testimonials = snap.data()['testimonials'] || [];
//     } else {
//       this.testimonials = [];
//     }
//   }
//   async loadServiceTypes(): Promise<void> {
//     const snap = await getDoc(doc(this.firestore, 'webdata', 'servicetypes'));

//     if (snap.exists()) {
//       this.serviceTypes = snap.data()['services'] || [];
//     } else {
//       this.serviceTypes = [];
//     }
//   }

//   @HostListener('window:scroll', [])
//   onWindowScroll(): void {
//     this.isScrolled = window.scrollY > 50;
//   }

//   @HostListener('document:click', ['$event'])
//   onDocumentClick(event: Event): void {
//     const target = event.target as HTMLElement;
//     if (!target.closest('.service-select-container')) {
//       this.serviceDropdownOpen = false;
//     }
//   }

//   scrollToSection(sectionId: string): void {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth' });
//       this.mobileMenuOpen = false;
//     }
//   }

//   toggleMobileMenu(): void {
//     this.mobileMenuOpen = !this.mobileMenuOpen;
//   }

//   toggleFaq(id: string): void {
//     this.faqItems = this.faqItems.map(item => ({
//       ...item,
//       isOpen: item.id === id ? !item.isOpen : false
//     }));
//   }

//   toggleServiceDropdown(): void {
//     this.serviceDropdownOpen = !this.serviceDropdownOpen;
//   }

//   selectService(service: string): void {
//     this.appointmentForm.patchValue({ service_type: service });
//     this.serviceDropdownOpen = false;
//   }

//   getRatingArray(rating: number): number[] {
//     return Array(rating).fill(0);
//   }
//   sendTelegramMessage(message: string): void {
//     const url = `https://api.telegram.org/bot${environment.telegramBotToken}/sendMessage`;

//     const payload = {
//       chat_id: environment.telegramChatId,
//       text: message,
//       parse_mode: 'HTML'
//     };

//     this.http.post(url, payload).subscribe({
//       next: () => console.log('✅ Telegram message sent'),
//       error: (err: any) => console.error('❌ Telegram error', err)
//     });
//   }
//   async onSubmit(): Promise<void> {
//     if (this.appointmentForm.invalid) {
//       this.showToastMessage('Please fill in all required fields', 'error');
//       return;
//     }

//     this.isSubmitting = true;

//     try {
//       const {
//         preferred_date,
//         preferred_time,
//         ...restFormData
//       } = this.appointmentForm.value;

//       const dateTimeString = preferred_time
//         ? `${preferred_date}T${preferred_time}`
//         : `${preferred_date}T00:00`;

//       const preferredDate = Timestamp.fromDate(
//         new Date(dateTimeString)
//       );

//       const appointmentDocRef = doc(
//         collection(this.firestore, 'appointments')
//       );

//       await setDoc(appointmentDocRef, {
//         docid: appointmentDocRef.id,
//         ...restFormData,
//         preferredDate,
//         status: 'pending',
//         created: serverTimestamp()
//       });

//       this.showToastMessage(
//         'Appointment request submitted successfully! We will contact you soon.',
//         'success'
//       );
//       this.sendTelegramMessage(`
//       <b>🆕 New Appointment Request</b>

//       <b>Name:</b> ${restFormData.patient_name}
//       <b>Phone:</b> ${restFormData.phone}
//       <b>Appointment Date:</b> ${preferred_date}
//       <b>Time:</b> ${preferred_time || 'Not specified'}
//       <b>Email:</b> ${restFormData.email}
//       <b>Service:</b> ${restFormData.service_type}
//       <b>Message:</b> ${restFormData.message}
//       <b>Status:</b> Pending
//       `);

//       this.appointmentForm.reset();

//     } catch (error) {
//       console.error('Error saving appointment:', error);
//       this.showToastMessage('Something went wrong. Please try again.', 'error');
//     } finally {
//       this.isSubmitting = false;
//     }
//   }

//   showToastMessage(message: string, type: 'success' | 'error'): void {
//     this.toastMessage = message;
//     this.toastType = type;
//     this.showToast = true;
//     setTimeout(() => {
//       this.showToast = false;
//     }, 5000);
//   }

//   closeToast(): void {
//     this.showToast = false;
//     }
//   getServiceIcon(svg: string): SafeHtml {
//     // Remove inline stroke/fill colors to let CSS take over
//     const cleanedSvg = svg
//       .replace(/stroke="[^"]*"/g, 'stroke="currentColor"')
//       .replace(/fill="(?!none)[^"]*"/g, 'fill="none"');
//     return this.sanitizer.bypassSecurityTrustHtml(cleanedSvg);
//   }

// }
import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  HostListener,
  inject,
  PLATFORM_ID
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import {
  Firestore,
  collection,
  doc,
  setDoc,
  serverTimestamp,
  Timestamp,
  getDoc,
  updateDoc,
  arrayUnion,
  onSnapshot
} from '@angular/fire/firestore';


import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SeoService } from '../seo.service';
import { TelegramService } from '../telegram.service';
import { VisitorTrackingService } from '../visitor-tracking.service';
import { runTransaction } from '@angular/fire/firestore';

/* ---------------- INTERFACES ---------------- */

interface Service {
  id: number;
  name: string;
  description: string;
  icon: {
    key: string;
    svg: string;
  };
  featured: boolean;
}

interface Doctor {
  id: number;
  doctorname: string;
  qualification: string;
  specialization: string;
  experience: string;
  imageurl: string;
}

interface Testimonial {
  id: number;
  testimonial: string;
  patientName: string;
  rating: number;
}

interface ClinicSettings {
  phone_numbers: string[];
  email: string;
  working_hours: string;
  address:string;
  locationUrl:string;
}

interface FAQItem {
  id: string;
  question: string;
  answer: string;
  isOpen: boolean;
}

/* ---------------- COMPONENT ---------------- */

@Component({
  selector: 'app-mainwebpage',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './mainwebpage.component.html',
  styleUrl: './mainwebpage.component.css'
})
export class MainWebpageComponent implements OnInit, AfterViewInit, OnDestroy {

  private firestore = inject(Firestore);
  private fb = inject(FormBuilder);
  private sanitizer = inject(DomSanitizer);
  private platformId = inject(PLATFORM_ID);
  private telegram = inject(TelegramService);
  private tracking = inject(VisitorTrackingService);

  services: Service[] = [];
  testimonials: Testimonial[] = [];
  doctors: Doctor[] = [];
  faqItems: FAQItem[] = [];
  serviceTypes: string[] = [];
  private timeConfigUnsub?: () => void;
  private appointmentTimesUnsub?: () => void;

  clinicSettings: ClinicSettings = {
    phone_numbers: ['+91 9361396199','+91 9941268494'],
    email: 'info@enlightenphysio.com',
    working_hours: 'Mon-Sat: 8AM - 8PM',
    address:'No.95 & 96, Varalakshmi nagar, 3rd main road, Maduravoyal, Chennai - 95, Landmark: Diagonally opp to Dr.M.G.R. University',
    locationUrl:'https://www.google.com/maps?q=13.0672876,80.1793802&z=17&hl=en'
  };

  isScrolled = false;
  mobileMenuOpen = false;
  serviceDropdownOpen = false;

  appointmentForm!: FormGroup;
  isSubmitting = false;

  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  showToast = false;

  currentYear = new Date().getFullYear();
  private seo = inject(SeoService);
  ImageTextItem: any[] = [
    {
      title: 'Proper Consultation',
      image: 'assets/1.png',
    },
    {
      title: 'Detailed Assessment',
      image: 'assets/2.png',
    },
    {
      title: 'Pain Management',
      image: 'assets/10.png',
    },
    {
      title: 'Personalized Rehabilitation',
      image: 'assets/4.png',
    },
    {
      title: 'Physio Assited Fitness',
      image: 'assets/5.png',
    },
    {
      title: 'Holistic Approach Practice',
      image: 'assets/6.png',
    },
    {
      title: 'Women Health Programs',
      image: 'assets/7.png',
    },
    {
      title: 'Nutrition & Diet Planning',
      image: 'assets/8.png',
    },
    {
      title: 'Lifestyle Modification',
      image: 'assets/11.png',
    },
  ];


  minDate = '';
  availableSlots: string[] = [];
  bookedSlots: string[] = [];

  timeConfig: any = null;
  weeklyHolidays: string[] = [];
  temporaryHolidays: Date[] = [];


  ngOnInit(): void {
  const today = new Date();
  this.minDate = today.toISOString().split('T')[0];
  this.availableSlots = this.generateSlotsFromConfig();

    this.seo.update({
      title: 'Enlighten Physio Spot | Physiotherapy & Sports Rehab',
      description:
        'Enlighten Physio Spot offers expert physiotherapy, sports injury rehabilitation, women’s health programs, and personalized care.',
      keywords:
        'physiotherapy clinic, sports rehab, physio near me, women health physiotherapy',
      image: 'https://enlightenphysiospot.com/assets/og-image.jpg',
      url: 'https://enlightenphysiospot.com'
    });

    this.appointmentForm = this.fb.group({
      patient_name: ['', Validators.required],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[0-9]{10}$/)   // ✅ only numbers & exactly 10 digits
        ]
      ],
      // phone: ['', Validators.required],
      email: ['', Validators.email],
      preferred_date: ['', Validators.required],
      preferred_time: [''],
      service_type: ['', Validators.required],
      message: ['']
    });

    // 🚫 Do NOT touch Firebase during SSR
    if (!isPlatformBrowser(this.platformId)) return;
    this.loadTimeConfiguration();
    this.loadServices();
    this.loadFaq();
    this.loadDoctors();
    this.loadTestimonials();
    this.loadServiceTypes();
  }
  onPhoneInput(event: Event) {

    const input = event.target as HTMLInputElement;

    const onlyNumbers = input.value.replace(/[^0-9]/g, '');

    input.value = onlyNumbers;

    this.appointmentForm
      .get('phone')
      ?.setValue(onlyNumbers, { emitEvent: false });
  }

  loadTimeConfiguration() {

    if (!isPlatformBrowser(this.platformId)) return;

    const ref = doc(this.firestore, 'settings', 'time configuration');

    this.timeConfigUnsub = onSnapshot(ref, snap => {

      if (!snap.exists()) return;

      this.timeConfig = snap.data();

      this.weeklyHolidays =
        (this.timeConfig.holiday || []).map((d: string) => d.toLowerCase());

      this.temporaryHolidays =
        (this.timeConfig.temporaryholiday || []).map((t: any) =>
          t.toDate()
        );

      this.availableSlots = this.generateSlotsFromConfig();

    });
  }

  parseTime(value: string): Date {

    const match = value.match(/(\d+):(\d+)(AM|PM)/i);

    if (!match) return new Date();

    let h = Number(match[1]);
    const m = Number(match[2]);
    const meridian = match[3].toUpperCase();

    if (meridian === 'PM' && h !== 12) h += 12;
    if (meridian === 'AM' && h === 12) h = 0;

    const d = new Date();
    d.setHours(h, m, 0, 0);

    return d;
  }
  isFullDayHoliday(): boolean {

    const selectedDate = this.appointmentForm.get('preferred_date')?.value;
    if (!selectedDate) return false;

    const date = new Date(selectedDate);

    /* weekly holiday */
    const dayName = date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

    if (this.weeklyHolidays.includes(dayName)) return true;

    /* temporary holiday */
    return this.temporaryHolidays.some(d =>
      d.toDateString() === date.toDateString()
    );
  }

  generateSlotsFromConfig(): string[] {

    if (!this.timeConfig) return [];

    const start = this.parseTime(this.timeConfig.starttime);
    const end   = this.parseTime(this.timeConfig.endtime);

    const step = this.timeConfig.visitdurationminutes || 45;

    const slots: string[] = [];

    let cursor = new Date(start);

    while (cursor <= end) {

      const h = cursor.getHours();
      const m = cursor.getMinutes();

      const ampm = h >= 12 ? 'PM' : 'AM';
      const hour12 = h % 12 || 12;

      slots.push(
        `${hour12}:${m.toString().padStart(2, '0')} ${ampm}`
      );

      cursor = new Date(cursor.getTime() + step * 60000);
    }

    return slots;
  }

  isPastSlot(slot: string): boolean {

    const selectedDate = this.appointmentForm.get('preferred_date')?.value;
    if (!selectedDate) return true;

    const today = new Date();
    const selected = new Date(selectedDate);

    // only apply for today
    if (today.toDateString() !== selected.toDateString()) return false;

    const [time, meridian] = slot.split(' ');
    const [h, m] = time.split(':').map(Number);

    let hour = h;
    if (meridian === 'PM' && h !== 12) hour += 12;
    if (meridian === 'AM' && h === 12) hour = 0;

    const slotDate = new Date(selected);
    slotDate.setHours(hour, m, 0, 0);

    return slotDate.getTime() <= today.getTime();
  }

  ngAfterViewInit(): void {
    // visitor logs (visitorlogs collection) — sections are in the DOM by now
    if (!isPlatformBrowser(this.platformId)) return;
    this.tracking.start();
  }

  ngOnDestroy(): void {
    if (this.timeConfigUnsub) this.timeConfigUnsub();
    if (this.appointmentTimesUnsub) this.appointmentTimesUnsub();
    this.tracking.stop();
  }
  generateSlots(): string[] {

    const slots: string[] = [];

    let start = new Date();
    start.setHours(8, 0, 0, 0);

    const end = new Date();
    end.setHours(20, 0, 0, 0);

    while (start <= end) {

      const h = start.getHours();
      const m = start.getMinutes();

      const ampm = h >= 12 ? 'PM' : 'AM';
      const hour12 = h % 12 || 12;

      slots.push(
        `${hour12}:${m.toString().padStart(2,'0')} ${ampm}`
      );

      start = new Date(start.getTime() + 45 * 60000);
    }

    return slots;
  }

  async onDateChange() {
  if (this.isFullDayHoliday()) {
    this.bookedSlots = [];
    this.appointmentForm.patchValue({ preferred_time: '' });
    return;
  }

    const date = this.appointmentForm.get('preferred_date')?.value;

    if (!date || !isPlatformBrowser(this.platformId)) return;

    this.bookedSlots = [];

    if (this.appointmentTimesUnsub) {
      this.appointmentTimesUnsub();
    }

    const ref = doc(this.firestore,'appointmenttimes',date);

    this.appointmentTimesUnsub = onSnapshot(ref, snap => {

      if (snap.exists()) {
        this.bookedSlots = snap.data()?.['times'] || [];
      } else {
        this.bookedSlots = [];
      }

    });


    this.appointmentForm.patchValue({ preferred_time: '' });
  }
  selectTimeSlot(slot: string){

    if(this.bookedSlots.includes(slot)) return;

    this.appointmentForm.patchValue({
      preferred_time: slot
    });
  }


  /* ---------------- FIRESTORE LOADERS (SSR SAFE) ---------------- */

  async loadServices(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;

    const snap = await getDoc(doc(this.firestore, 'webdata', 'services'));
    this.services = snap.exists() ? snap.data()?.['services'] || [] : [];
  }

  async loadFaq(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;

    const snap = await getDoc(doc(this.firestore, 'webdata', 'faq'));
    this.faqItems = snap.exists() ? snap.data()?.['faq'] || [] : [];
  }

  async loadDoctors(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;

    const snap = await getDoc(doc(this.firestore, 'webdata', 'doctors'));
    this.doctors = snap.exists() ? snap.data()?.['doctors'] || [] : [];
  }

  async loadTestimonials(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;

    const snap = await getDoc(doc(this.firestore, 'webdata', 'testimonials'));
    this.testimonials = snap.exists() ? snap.data()?.['testimonials'] || [] : [];
  }

  async loadServiceTypes(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;

    const snap = await getDoc(doc(this.firestore, 'webdata', 'servicetypes'));
    this.serviceTypes = snap.exists() ? snap.data()?.['services'] || [] : [];
  }

  /* ---------------- UI HANDLERS ---------------- */

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.isScrolled = window.scrollY > 50;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const target = event.target as HTMLElement;
    if (!target.closest('.service-select-container')) {
      this.serviceDropdownOpen = false;
    }
  }

  scrollToSection(sectionId: string): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
    this.mobileMenuOpen = false;
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  toggleFaq(id: string): void {
    this.faqItems = this.faqItems.map(item => ({
      ...item,
      isOpen: item.id === id ? !item.isOpen : false
    }));
  }

  toggleServiceDropdown(): void {
    this.serviceDropdownOpen = !this.serviceDropdownOpen;
  }

  selectService(service: string): void {
    this.appointmentForm.patchValue({ service_type: service });
    this.serviceDropdownOpen = false;
  }

  getRatingArray(rating: number): number[] {
    return Array(rating).fill(0);
  }

  /* ---------------- TELEGRAM + APPOINTMENT ---------------- */

  sendTelegramMessage(message: string): void {
    this.telegram.sendMessage(message);
  }
  async generateAppointmentId(): Promise<string> {

    const counterRef = doc(this.firestore, 'settings', 'appointmentCounter');

    const nextNumber = await runTransaction(this.firestore, async (tx) => {

      const snap = await tx.get(counterRef);

      let current = 0;

      if (snap.exists()) {
        current = snap.data()['current'] || 0;
      }

      const newValue = current + 1;

      tx.set(counterRef, { current: newValue }, { merge: true });

      return newValue;
    });

    return `EP${nextNumber}`;
  }

  async onSubmit(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;

    if (this.appointmentForm.invalid) {
      this.showToastMessage('Please fill in all required fields', 'error');
      return;
    }

    this.isSubmitting = true;

    try {
      const { preferred_date, preferred_time, ...rest } = this.appointmentForm.value;

      const [time, meridian] = preferred_time.split(' ');
      const [h, m] = time.split(':').map(Number);

      let hour = h;
      if (meridian === 'PM' && h !== 12) hour += 12;
      if (meridian === 'AM' && h === 12) hour = 0;

      const combined = new Date(preferred_date);
      combined.setHours(hour, m, 0, 0);

      const preferredDate = Timestamp.fromDate(combined);

      // const { preferred_date, preferred_time, ...rest } = this.appointmentForm.value;

      // const preferredDate = Timestamp.fromDate(
      //   new Date(preferred_time
      //     ? `${preferred_date}T${preferred_time}`
      //     : `${preferred_date}T00:00`)
      // );

      const ref = doc(collection(this.firestore, 'appointments'));
      const selectedDate = this.appointmentForm.value.preferred_date;
      const selectedTime = this.appointmentForm.value.preferred_time;

      if(!selectedTime){
        this.showToastMessage('Please select a time slot','error');
        this.isSubmitting = false;
        return;
      }
      const appointmentid = await this.generateAppointmentId();

      await setDoc(ref, {
        docid: ref.id,
        ...rest,
        appointmentid,
        preferredDate,
        preferredTime: selectedTime,
        status: 'pending',
        created: serverTimestamp()
      });
      const timeRef = doc(this.firestore,'appointmenttimes',selectedDate);

      const timeSnap = await getDoc(timeRef);

      if(timeSnap.exists()){
        await updateDoc(timeRef,{
          times: arrayUnion(selectedTime)
        });
      }else{
        await setDoc(timeRef,{
          date: selectedDate,
          times: [selectedTime],
          created: serverTimestamp()
        });
      }

      this.showToastMessage('Appointment request submitted successfully!', 'success');
      this.tracking.markAppointmentBooked();
      this.sendTelegramMessage(`
        <b>New Appointment</b>
        <b>Appointment ID:</b> ${appointmentid}
        <b>Name:</b> ${rest.patient_name}
        <b>Phone:</b> ${rest.phone}
        <b>Appointment Date:</b> ${preferred_date}
        <b>Time:</b> ${preferred_time || 'Not specified'}
        <b>Email:</b> ${rest.email}
        <b>Service:</b> ${rest.service_type}
        <b>Message:</b> ${rest.message}
        <b>Status:</b> Pending
        `);

      this.appointmentForm.reset();

    } catch {
      this.showToastMessage('Something went wrong. Please try again.', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  /* ---------------- TOAST ---------------- */

  showToastMessage(message: string, type: 'success' | 'error'): void {
    this.toastMessage = message;
    this.toastType = type;
    this.showToast = true;

    setTimeout(() => (this.showToast = false), 5000);
  }

  closeToast(): void {
    this.showToast = false;
  }

  /* ---------------- SVG ---------------- */

  getServiceIcon(svg: string): SafeHtml {
    const cleanedSvg = svg
      .replace(/stroke="[^"]*"/g, 'stroke="currentColor"')
      .replace(/fill="(?!none)[^"]*"/g, 'fill="none"');

    return this.sanitizer.bypassSecurityTrustHtml(cleanedSvg);
  }
}
